import styled from 'styled-components';
import { layout } from 'styled-system';
export var Container = styled.div.withConfig({
  displayName: "FilterListValuestyles__Container",
  componentId: "keen-query-creator__sc-tthidx-0"
})(["&&&{position:relative;}"]);
export var DropdownContainer = styled.div.withConfig({
  displayName: "FilterListValuestyles__DropdownContainer",
  componentId: "keen-query-creator__sc-tthidx-1"
})(["&&&{width:280px;padding:14px;box-sizing:border-box;}"]);
export var ItemContainer = styled.div.withConfig({
  displayName: "FilterListValuestyles__ItemContainer",
  componentId: "keen-query-creator__sc-tthidx-2"
})(["&&&{max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}"]);
export var ListItem = styled.div.withConfig({
  displayName: "FilterListValuestyles__ListItem",
  componentId: "keen-query-creator__sc-tthidx-3"
})(["&&&{margin-top:6px;margin-right:10px;}"]);
export var List = styled.div.withConfig({
  displayName: "FilterListValuestyles__List",
  componentId: "keen-query-creator__sc-tthidx-4"
})(["&&&{display:flex;flex-wrap:wrap;overflow:auto;", ";}"], layout);